import { useState, useEffect, useRef, forwardRef } from 'react';
import { animated, useSpring, easings } from '@react-spring/web';
import { colors } from '../../constants';

export const PillButtons = forwardRef((props, ref) => {
  const { value, onChange, choices, wrapperStyle, pillStyle, activeStyle, highlightStyle, size } = props;
  const refs = useRef({});
  const relativeRef = useRef();
  const [springs, api] = useSpring(() => ({}));
  const [box, setBox] = useState({});

  useEffect(() => {
    setTimeout(() => handleChange(value), 100);
    setTimeout(() => handleChange(value), 200);
    setTimeout(() => handleChange(value), 300);
  }, []);

  useEffect(() => {
    setTimeout(() => handleChange(value), 300);
  }, [value]);

  const borderRadius = 5;
  const handleChange = (updated) => {
    onChange(updated);

    const el = refs.current[updated];
    const rect = el?.getBoundingClientRect();

    const prevEl = refs.current[value];
    const prevRect = prevEl?.getBoundingClientRect();

    const relativeEl = relativeRef?.current;
    const relativeRect = relativeEl?.getBoundingClientRect();

    const duration = 200;

    setBox({});

    const left = rect && relativeRect ? rect.x - relativeRect.x : 0;

    if (rect && prevRect) {
      api.start({
        from: {
          left: prevRect.x - relativeRect.x,
          width: prevRect.width,
          height: prevRect.height,
        },
        to: {
          left,
          width: rect.width,
          height: rect.height,
        },
        config: {
          duration,
          easing: easings.easeOutCubic,
        },
      });
    }

    if (rect) {
      setTimeout(() => {
        setBox({
          left,
          relativeLeft: relativeRect.x,
          width: rect.width,
          height: rect.height,
        });
      }, duration);
    }
  };

  useEffect(() => {
    handleChange(value);
  }, []);

  const render = ([val, label], idx, isBg) => {
    const activeStyle_ = {
      color: colors.primaryDark,
      zIndex: 2,
      ...(activeStyle || {}),
    };

    if (isBg) {
      activeStyle_.background = colors.primaryLight;
    }

    let sizeStyles;
    if (size == 'sm') {
      sizeStyles = {
        fontSize: 12,
        padding: '5px 12px',
        borderRadius: 24,
      };
    }

    const style = {
      cursor: 'pointer',
      padding: '6px 18px',
      textAlign: 'center',
      userSelect: 'none',
      borderRadius,
      ...sizeStyles,
      ...(pillStyle || {}),
      ...(val == value ? activeStyle_ : {}),
    };

    return (
      <div
        key={val}
        style={style}
        onClick={() => handleChange(val)}
        ref={(el) => {
          refs.current[val] = el;
        }}
      >
        <span style={{ visibility: isBg ? 'hidden' : undefined }}>{label || val}</span>
      </div>
    );
  };

  const nodes = choices.map((args, idx) => render(args, idx, false));
  // const nodes2 = choices.map((args, idx) => render(args, idx, true));

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    borderRadius,
    ...wrapperStyle,
  };

  return (
    <div ref={relativeRef} style={{ position: 'relative' }}>
      <animated.div
        style={{
          position: 'absolute',
          background: colors.primaryLight,
          zIndex: 1,
          borderRadius,
          ...highlightStyle,
          ...springs,
          ...box,
        }}
      >
        &nbsp;
      </animated.div>
      <div style={containerStyle}>{nodes}</div>
    </div>
  );
});
